import { render, staticRenderFns } from "./segmentsMetrics.vue?vue&type=template&id=c5dad91a&"
import script from "./segmentsMetrics.vue?vue&type=script&lang=ts&"
export * from "./segmentsMetrics.vue?vue&type=script&lang=ts&"
import style0 from "./segmentsMetrics.vue?vue&type=style&index=0&id=c5dad91a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSelect,VTooltip})
